<template>
  <div>
    <v-divider></v-divider>
    <v-footer dark>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-layout wrap justify-center>
            <v-flex align-self-center xs12 px-md-4 px-lg-6>
              <v-layout
                wrap
                justify-center
                :text-left="$vuetify.breakpoint.name == 'xs' ? true : false"
              >
                <v-flex xs12 sm2 md2 lg2 align-self-center>
                  <v-layout wrap justify-start>
                    <v-flex xs2 sm1 md1 lg1 align-self-center text-left>
                      <router-link class="routerlink" :to="(name = '/')">
                        <span class="maintitle"> TIGERTHON </span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm1 md1 lg6 align-self-center>
                  <v-layout wrap justify-end>
                    <v-flex sm12 md12 lg12 align-self-center>
                      <v-layout wrap>
                        <v-flex
                          v-for="(item, i) in menus"
                          :key="i"
                          md2
                          lg2
                          align-self-center
                          text-center
                        >
                          <router-link class="routerlink" :to="item.route">
                            <span
                              :class="
                                $vuetify.breakpoint.name == 'md'
                                  ? 'MDapplistF'
                                  : 'LGapplistF'
                              "
                              >{{ item.name }}</span
                            >
                          </router-link>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  sm8
                  md6
                  lg4
                  align-self-center
                  
                >
                  <v-layout
                    wrap
                    :class="
                      $vuetify.breakpoint.name == 'md'
                        ? 'MDapplistF'
                        : 'LGapplistF'
                    "
                  >
                    <v-flex>
                      <span>#tigerthon</span>
                    </v-flex>
                    <v-flex>
                      <span>#savestripes </span>
                    </v-flex>
                    <v-flex>
                      <span>#savethestripes</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // userNavItems: [
      //   { name: "Rules", route: "/" },
      //   { name: "Resources", route: "/" },
      //   { name: "Project", route: "/" },
      //   { name: "Updates", route: "/" },
      //   { name: "Discussion", route: "/" },
      //   { name: "FAQ", route: "/" },
      // ],
      userNavItems: [
      ],
    };
  },
  computed: {
    menus() {
      return this.userNavItems;
    },
  },
};
</script>